const navLinks1 = [
  { label: "Home", destination: "/" },
  { label: "About", destination: "/about-us" },
  { label: "Blog ", destination: "/blog" },
 
];
const navLinks2 = [
  { label: "Resume Maker", destination: "/resume-maker" },
  { label: "Contact", destination: "/contact" },
];
const navLinks2opt = [
  { label: "Job Seekers", destination: "/job-seeker" },
  { label: "Hire Talent", destination: "/hire-talent" },
];

const links = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about-us" },
  { name: "Resume Maker", href: "/resume-maker" },
  { name: "Find Job", href: "/job-seeker" },
  { name: "Hire Talent", href: "/hire-talent" },
  { name: "Blog", href: "/blog" },
  { name: "Contact Us", href: "/contact" },
];

const candidatereviews = [
  {
    name: 'Siddharth Dhadda',
    position: 'Software Engineer',
    image: '/8.webp',
    review: 'The experts provided excellent consultation, which in turn helped me secure a position in a top organization.',
    stars: 5
  },
  {
    name: 'Yashvardhan Sharma',
    position: 'Data Analyst',
    image: '/10.webp',
    review: 'What one individual fresher or job seeker can expect from the hiring team is that they have everything to provide you.',
    stars: 4
  },
  {
    name: 'Xavier ajay gomes',
    position: 'Customer support associate',
    image: '/1a.webp',
    review: 'The Direct Hire team is excellent at their work. They have so many companies for getting better opportunities for every candidate according to their interest, so they helped me get a good opportunity. Special thanks to Ayushi Ma\'am.',
    stars: 5
  },
  {
    name: 'Krish sharma',
    position: 'Senior customer support',
    image: '/4a.webp',
    review: 'Throughout the process, the team was incredibly professional and supportive. They provided me with guidance at every stage and helped me in securing an opportunity that\'s the perfect fit for my skills and future.',
    stars: 5
  },
  {
    name: 'Sachin singh rawat',
    position: 'Inside sales executive',
    image: '/6a.webp',
    review: 'Ayushi ma’am consistently provided me with support, which helped me to secure a job in a top organization in Gurgaon. She understood my requirements and connected me with the right opportunity.',
    stars: 5
  },
  {
    name: 'Harshita Saini',
    position: 'Academic counsellor',
    image: '/2a.webp',
    review: 'I didn\'t know that a consultancy can think from a candidate’s perspective! Priyanshi and Nitin were very helpful in salary negotiations.',
    stars: 4
  },
  {
    name: 'Sheffali Suman',
    position: 'Inside sales representative',
    image: '/5.webp',
    review: 'I had been experiencing problems in finding a suitable job opportunity; however, Nitin helped me in recognizing my skills and finding the right job.',
    stars: 5
  },
  {
    name: 'Anjali Mehta',
    position: 'Business Analyst',
    image: '/9.webp',
    review: 'Priyanshi was very helpful throughout the process. I am truly grateful for the effort she made to understand my goals.',
    stars: 5
  },
  {
    name: 'Ritika Chauhan',
    position: 'Project Coordinator',
    image: '/3.webp',
    review: 'Direct Hire has a broad network of companies that they hire for and uses a professional approach.',
    stars: 4
  },
  {
    name: 'Yashwardhan sharma',
    position: 'Business development executive',
    image: '/10.webp',
    review: 'I was amazed by the speed with which they responded and scheduled interviews for me. Their assistance helped me perform well in the interview and secure the job.',
    stars: 5
  }
];

const sections = [
  {
    title: "More Than Recruitment — A Mission-Driven Talent Platform",
    text: "Direct Hire is more than just a recruitment agency. It’s a platform built on the belief that quality hiring shouldn't be slow, impersonal, or based on outdated methods. Today, we work with a wide range of clients across IT and Non-IT sectors — from agile startups to growing corporates — helping them close positions quickly without compromising on quality. Behind every successful placement is our ever-evolving talent community: skilled professionals from diverse backgrounds who we actively support, nurture, and help grow through upskilling and career development initiatives.",
    image: "/ab1.webp",
    style: "rounded-[20%]"
  },
  {
    title: "Precision Over Volume — Our Unique Hiring Philosophy",
    text: "What truly sets us apart is our approach. Where most agencies focus on volume, we’re obsessed with fit. We take the time to understand the needs behind every role and go beyond resumes to find candidates who align in skills, mindset, and potential. Our turnaround times are fast, but never rushed — because we believe quality hiring is about precision, not pressure.",
    image: "/ab2.webp",
    reverse: true,
    style: "rounded-[20%]"
  },
  {
    title: "From One to Many — The Team Powering the Vision",
    text: "What started as a solo mission has now grown into a team of 15+ passionate individuals, all driven by the same mission: to close the hiring gap with speed, care, and clarity. We’re building a future where hiring isn’t just a transaction — it’s a meaningful match between talent and opportunity. And we're just getting started.",
    image: "/ab3.webp",
    style: "rounded-[20%]"
  }
];

const industryData = [
  {
    label: "Sales & Business Development ",
    link: "",
    icon: "/sales.webp",
  },
  {
    label: "Banking & Insurance ",
    link: "",
    icon: "/savings.webp",
  },
  {
    label: "Information Technology (IT) ",
    link: "",
    icon: "/information-technology_17735653.webp",
  },
  {
    label: "Customer Support & BPO ",
    link: "",
    icon: "/customer-service.webp",
  },
  {
    label: "Education & EdTech",
    link: "",
    icon: "/school.webp",
  },
  {
    label: "Real Estate",
    link: "",
    icon: "/agreement.webp",
  },
  {
    label: "Media, Marketing & Communications ",
    link: "",
    icon: "/bullhorn.webp",
  },
  {
    label: "E-commerce & Retail ",
    link: "",
    icon: "/ecommerce.webp",
  },
   {
    label: "Logistics & Supply Chain  ",
    link: "",
    icon: "/logistics.webp",
  },
   {
    label: "Travel, Tourism & Hospitality ",
    link: "",
    icon: "/travel-and-tourism.webp",
  },
   {
    label: "Startups & Entrepreneurship ",
    link: "",
    icon: "/start-up.webp",
  },
   {
    label: "Design & Creative Arts ",
    link: "",
    icon: "/web-design.webp",
  },
];
 const jobcontent = {
        title: "Job Seeker",
        sections: [
            {
                subheading: "Direct Hiring Support ",
                body: "Whether you're a fresher in marketing or a 3-year experienced developer, we have opportunities for you. We are hiring for 20+ companies in various domains in both IT and non-IT sectors. We help you find your next job effortlessly and connect you with the top companies. We streamline the process and help you throughout the process from interview to joining.",
            },
            {
                subheading: "Professional Resume Builder ",
                body: "We have built a resume builder, which you can use to make a professional resume that helps you stand out in a job application and improves your chances of being a top applicant.",
            },
          
        ],
        buttonPrimary: "Find Job",
        buttonSecondary: "Build Resume",
    };

 const hirecontent = {
        title: "Hire Talent",
        sections: [
            {
                subheading: "Pre-Screened Candidates",
                body: "We have a pool of data sourced from various platforms and references over the past few years, which helps us fill the positions quickly. ",
            },
            {
                subheading: "What makes us different? ",
                body: "We use AI filters and CRMs to filter out candidates on the basis of skills. Our experienced recruiters then rescreen these filtered-out candidates, giving them extra attention. This AI-plus-human effort helps us save time, get more relevant profiles required for a job, and fill a position faster. ",
            },
            {
                subheading: "The Talent network",
                body: "We’ve built a thriving community of top candidates from diverse fields and cities across India, bringing together talent from both tech and non-tech domains. Our mission is to empower them by facilitating upskilling in industry-relevant skills that drive meaningful career growth. We hire from the community itself to make sure you get the best talent.",
            },
        ],
        buttonPrimary: "Hire Now",
        buttonSecondary: "Talk to Consultant",
    };


const hiringcompanysreviews = [
  {
    name: 'Handpickd',
    position: 'Aamir Khan, Senior HR, Handpickd',
    image: '/handpick.JPG',
    review: 'We had to scale rapidly and hire over 30 Inside Sales Representatives and City Marketing Managers in less than a month—Ayushi and her team pulled it off seamlessly. From shortlisting and interviews to document collection and ensuring every candidate joined on time, Direct Hire handled it all. They understood our requirements better than most internal teams do!',
    stars: 5
  },

    {
    name: 'Yellow Hospitality and Tourism Pvt Ltd',
    position: '— Divita Jain, HR Manager, Yellow Hospitality',
    image: '/Yellow.JPG',
    review: 'Finding the right candidates for roles like International Holiday Consultant and Accounts Executive isn’t easy in our industry, but Direct Hire delivered exactly what we needed. Their speed, quality of candidates, and professionalism made the entire process smooth and stress-free',
    stars: 5
  },

    {
    name: 'Sayesha Enterprises',
    position: 'Rajiv Dhulia, Founder, Sayesha Enterprises',
    image: '/Sayesha.JPG',
    review: 'Hiring women for night shifts in an international BPO setup in Kolkata—and within budget—is a real challenge. Direct Hire not only accepted that challenge but exceeded expectations by placing over 20 quality candidates. Their effort, persistence, and understanding of our exact requirements truly stood out.',
    stars: 5
  },

    {
    name: 'Coreflex',
    position: 'Deepak Kewlani, Founder, Coreflex',
    image: '/icon+text(blue) transparent.png',
    review: 'As a new brand in the activewear space, we needed enthusiastic and aligned team members. Direct Hire helped us build our founding team with people who genuinely believe in our vision. Couldn’t have asked for more.',
    stars: 5
  },

    {
    name: ' Ruva Skincare',
    position: 'Reena Agarwal, Founder, Ruva Skincare',
    image: '/Ruva.PNG',
    review: 'We were just starting out and needed help building our backend operations team. Direct Hire stepped in and took care of it end-to-end. Their ability to understand our workflow and find people who matched our mindset was impressive.',
    stars: 5
  },

    {
    name: 'Altruist Technologies',
    position: 'Joydeep Ray, Vice President, Altruist Technologies',
    image: '/Altruist.PNG',
    review: 'We’ve worked with many agencies, but what sets Direct Hire apart is their consistency and commitment. They take ownership of the roles and follow up rigorously until it’s closed. Great experience every time.',
    stars: 5
  },

    {
    name: 'Talli Tales',
    position: ' Komal Agarwal, Co-Founder, Talli Tales',
    image: '/Talli.PNG',
    review: 'Hiring for the alcohol industry is a very niche task, especially in sales. Direct Hire helped us find the right candidate who understood both the industry and the nature of the product. Their approach was quick, focused, and efficient',
    stars: 5
  },

    {
    name: 'Prizma Academy',
    position: ' Sahil Parnami, Founder, Prizma Academy',
    image: '/Prizma.JPG',
    review: 'We were expanding operations from Bangalore to Jaipur and needed to build a fresh team of Academic Counselors from scratch. Direct Hire helped us set up the entire hiring pipeline—from sourcing to onboarding—with complete ownership. Their local understanding and swift execution made the transition smooth and stress-free.',
    stars: 5
  },

    {
    name: 'Reenaas Fashion',
    position: '',
    image: '/reenaas.JPG',
    review: 'We recently needed to hire a shipping manager for Reenaas Fashion and decided to go through DirectHire in Jaipur. I was pleasantly surprised by how easy they made the whole process. The team really took the time to understand exactly what we were looking for n came back with some excellent candidates. We ended up hiring a perfect fit for the role. It’s clear that DirectHire knows what they’re doing n they care about getting it right. I highly recommend them if ur looking for reliable n efficient staffing help!',
    stars: 5
  },
]    
export{
    navLinks1,
    navLinks2,
    navLinks2opt,
    links,
    candidatereviews,
    sections,
    industryData,
    jobcontent,
    hirecontent,
    hiringcompanysreviews
}